import React, { useState } from "react";
import axios from "axios";
import { BiMailSend } from "react-icons/bi";
import { toast } from "react-toastify";

function ContactForm() {
  const [serverState, setServerState] = useState({
    submitting: false,
    status: null,
  });
  const handleServerResponse = (ok, msg, form) => {
    setServerState({
      submitting: false,
      status: { ok, msg },
    });
    if (ok) {
      form.reset();
      toast.success("Email sent successfully.", {
        toastId: "success1",
      });
    } else {
      toast.success("Error! Please try again.", {
        toastId: "error1",
      });
    }
  };
  const handleOnSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    setServerState({ submitting: true });
    axios({
      method: "post",
      url: "https://formspree.io/moqrbnqw",
      data: new FormData(form),
    })
      .then((r) => {
        handleServerResponse(true, "Success", form);
      })
      .catch((r) => {
        handleServerResponse(false, r.response.data.error, form);
      });
  };
  return (
    <div>
      <form onSubmit={handleOnSubmit}>
        <label className="label" htmlFor="name">
          <span className="label-text">Name</span>
        </label>
        <input
          className="input rounded input-bordered w-full"
          id="name"
          type="text"
          name="name"
          required
        />
        <label className="label" htmlFor="email">
          <span className="label-text">Email</span>
        </label>
        <input
          className="input rounded input-bordered w-full"
          id="email"
          type="email"
          name="email"
          required
        />
        <label className="label" htmlFor="message">
          <span className="label-text">Message</span>
        </label>
        <textarea
          className="textarea rounded textarea-bordered w-full"
          id="message"
          name="message"
        ></textarea>

        <button
          className="myBtn mx-0 w-full mt-3"
          type="submit"
          disabled={serverState.submitting}
        >
          <BiMailSend className="text-xl mr-2" />
          Send
        </button>
      </form>
    </div>
  );
}

export default ContactForm;
